export default __webpack_public_path__ + "static/media/avatar.296bf989.svg";